import React from 'react';

const MoMComparison = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="mb-4">
            <h5 className="mb-3 border-bottom pb-2">Month-over-Month Comparison</h5>
            <div className="card shadow-sm">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-sm table-hover mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th style={{ width: '15%' }}>Category</th>
                                    <th style={{ width: '25%' }}>Metric</th>
                                    <th className="text-end" style={{ width: '20%' }}>Current Month</th>
                                    <th className="text-end" style={{ width: '20%' }}>Previous Month</th>
                                    <th className="text-end" style={{ width: '20%' }}>Change</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((category, ci) => (
                                    category.metrics?.map((metric, mi) => {
                                        const isUp = metric.is_up ?? metric.change >= 0;
                                        const changeColor = isUp ? 'text-success' : 'text-danger';
                                        const sign = metric.change >= 0 ? '+' : '';

                                        const formatVal = (v) => {
                                            const n = Number(v);
                                            if (Number.isInteger(n)) return n.toLocaleString();
                                            return n.toLocaleString(undefined, { minimumFractionDigits: 3 });
                                        };

                                        return (
                                            <tr key={`${ci}-${mi}`}>
                                                {mi === 0 && (
                                                    <td rowSpan={category.metrics.length} className="fw-semibold" style={{ verticalAlign: 'middle' }}>
                                                        {category.category}
                                                    </td>
                                                )}
                                                <td>{metric.label}</td>
                                                <td className="text-end">{formatVal(metric.current)}</td>
                                                <td className="text-end">{formatVal(metric.previous)}</td>
                                                <td className={`text-end fw-bold ${changeColor}`}>
                                                    {sign}{metric.change}%
                                                </td>
                                            </tr>
                                        );
                                    })
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MoMComparison;
